import type { CalculateOffersPerson } from '@/services/inventory-api.service';
import type { SkierCounts } from '@/store/book-ski-pass.store';

export function buildSkierCountOffersFetchKey(
  domainIds: number[],
  stepTwo: { startingDate: string; daysOfSkiing: string; skierCounts: SkierCounts },
  people: CalculateOffersPerson[]
): string {
  const ids = domainIds
    .slice()
    .sort((a, b) => a - b)
    .join(',');
  return `${ids}|${stepTwo.startingDate}|${stepTwo.daysOfSkiing}|${JSON.stringify(people)}`;
}
